import { Component, OnInit, Input } from '@angular/core';
import { GroupService } from 'src/app/services/group.service';
import { Group } from 'src/app/models/group';
import { Cron } from 'src/app/services/cron';

@Component({
  selector: 'app-group-settings',
  templateUrl: './group-settings.component.html',
  styleUrls: ['./group-settings.component.css']
})
export class GroupSettingsComponent implements OnInit {
  @Input() group: Group;

  selectedTime: string;
  selectedWday: string;
  selectedWnum: string;
  timeOptions = [];

  constructor(private groupService: GroupService) {
    this.buildTime();
  }

  private buildTime() {
    var hours = Array.from(Array(24).keys());
    var mins = ["00", "15", "30", "45"];
    hours.forEach(hour => {
      mins.forEach(min => {
        this.timeOptions.push(`${(hour < 10) ? "0" : ""}${hour}:${min}`);
      });
    });
  }

  ngOnInit() {
    if (this.group != null) {
      var cron = Cron.parse(this.group.meetups);
      this.selectedTime = `${(parseInt(cron.hour) < 10) ? '0' : ''}${cron.hour}:${parseInt(cron.minute)<10 ? "0": ""}${cron.minute}`;
      this.selectedWday = cron.weekday;
      this.selectedWnum = cron.weeknum;
    }
  }

  save() {
    this.group.meetups = this.getCron();
    this.groupService.updateSettings(this.group);
    $('#btnSave').html("&#10004; Save");
  }

  getCron() {
    var time = this.selectedTime.split(":");
    return new Cron(time[1], time[0], '', '', this.selectedWday, this.selectedWnum).toString();
  }
}
